document.addEventListener('DOMContentLoaded', function () {
  // console.log(`main.js – DOMContentLoaded!`)

  // const hello = () => 'hello world!'

  // console.log(hello())

  // const es6Test = async () => {
  //   console.log(`es6Test`)
  //   await new Promise((resolve) => setTimeout(2000, resolve))
  // }

  // es6Test()
  var scrollTopTarget = document.querySelector('.l-footer__outer')
  var scrollToTopBtn = document.querySelector('.c-scroll-top')

  function scrollTopCallback(entries, observer) {
    // The callback will return an array of entries, even if you are only observing a single item
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Show button
        scrollToTopBtn.classList.add('c-scroll-top--show')
      } else {
        // Hide button
        scrollToTopBtn.classList.remove('c-scroll-top--show')
      }
    })
  }

  let scrollTopObserver = new IntersectionObserver(scrollTopCallback)
  scrollTopObserver.observe(scrollTopTarget)

  /* lightbox
  ---------------------------------------- */
  
  // lightbox for immo detail

  let gallery = document.querySelectorAll('.inx-gallery__images.uk-slideshow-items');
  imagesLoaded(gallery, function () {
    console.log(`imagesLoaded 2`);
    baguetteBox.run('.inx-gallery__images.uk-slideshow-items', {
      noScrollbars: false,
      animation: 'fadeIn'
      // captions: function (element) {
      //   let anchorEl = element.parentElement;
      //   let caption = "";
      //   let nextSiblingEl = anchorEl.nextElementSibling;
      //   if (nextSiblingEl) {
      //     caption = nextSiblingEl.textContent;
      //   }
      //   console.log(`caption: ${caption}`)

      //   return caption;
      // }      
    })
  })

    // create lightbox for <a> children of container with data-lightbox="true" attribute

    // use [data-lightbox^="true-"] as selector:
    // every lightbox trigger must be unique (i.e. data-lightbox="true-3453453453"])
    // if not, baguettebox will include all links in one single lightbox


    // baguetteBox.run('[data-lightbox^="true-"]', {
    //   // baguetteBox.run('[data-lightbox^="true-"]', {
    //   captions: true,
    //   noScrollbars: false,
    //   animation: 'fadeIn'
    //   // overlayBackgroundColor: '#4c4c4b',

    //   // add disabled attributes on buttons for first/last image

    //   // onChange: (currentIndex, imagesCount) => {
    //   //   let isLast = currentIndex == imagesCount - 1 ? true : false
    //   //   let isFirst = currentIndex == 0 ? true : false
    //   //   let nextEle = document.getElementById('next-button')
    //   //   let prevEle = document.getElementById('previous-button')
    //   //   nextEle.removeAttribute('disabled')
    //   //   prevEle.removeAttribute('disabled')
    //   //   if (isLast) {
    //   //     nextEle.setAttribute('disabled', '')
    //   //   }
    //   //   if (isFirst) {
    //   //     prevEle.setAttribute('disabled', '')
    //   //   }
    //   // }
    // })
})
